import styled from "styled-components";
import { Flex } from "../../assets/ui";

export const StyledRolesList = styled(Flex)`
  flex-direction: column;
  margin-top: 58px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.queries.sm}) {
    flex-direction: row;
  }
`;

export const StyledRole = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  background: #1e2a3c;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 8px;

  & > .location {
    background: rgba(110, 149, 203, 0.06);
    border-radius: 4px;
    font-size: 14px;
    line-height: 22px;
    color: #96a8be;
    padding: 5px 10px;
    margin-bottom: 14px;

    & > svg {
      margin-right: 8px;
    }
  }

  & > h4 {
    font-weight: 600;
    font-size: 21px;
    line-height: 26px;
    color: #ffffff;
    margin-bottom: 8px;
  }
  
  & > button {
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    background: #ed3163;
    border-radius: 26px;
    padding: 13px;
    color: #ffffff;
    cursor: pointer;
  }
  
  & > p {
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
    margin-bottom: 25px;
  }
`;

export const Description = styled(Flex)`
  padding-left: 16px;
  border-left: 3px solid ${({ theme }) => theme.colors.mainPink};
  font-weight: normal;
  margin-top: 46px;
  font-size: 18px;
  line-height: 24px;
  color: #586981;
  height: fit-content;
`;

export const StyledSectionWrapper = styled(Flex)`
  padding: 54px 24px 70px;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    padding: 75px 80px 150px;
    max-width: 1280px;
    margin: 0 auto;
  }
`;
